import { Pipe, PipeTransform } from '@angular/core';
import { numberFormatter, currencyFormatter, dateFormatter } from '@shared/helpers/functions/helpers';

/* eslint-disable id-blacklist */
type PipeOptions = 'number' | 'currency' | 'date';

type PipeFunctions = {
    [key in PipeOptions]: (value: string | number | Date, args?: string) => string | Date; // Note the "in" operator.
};

@Pipe({
    name: 'dynamic',
    standalone: false,
})
export class DynamicPipe implements PipeTransform {
    pipeOptions: PipeFunctions = {
        number: numberFormatter as (value: string | number | Date, args?: string) => string,
        currency: currencyFormatter as (value: string | number | Date, args?: string) => string,
        date: dateFormatter as (value: string | number | Date, args?: string) => string,
    };

    public constructor() {}

    transform(value: number, pipeType: 'number' | 'currency', pipeArgs?: string): string;
    transform(value: string | Date, pipeType: 'date', pipeArgs?: string): string | Date;
    transform(value: number | string | Date, pipeType: PipeOptions, pipeArgs?: string): string | Date {
        const pipe = this.pipeOptions[pipeType];
        return pipe ? (pipeArgs ? pipe(value, pipeArgs) : pipe(value)) : typeof value === 'number' ? String(value) : value;
    }
}
